import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { z } from "zod";

import { zCodingOptional } from "@/utils/zod";

const ProceduresForm = z
  .object({
    cptCode: zCodingOptional(),
    cptCodeNotes: z.string().optional(),
    cptDiagnosesFormset: z
      .record(
        z.union([z.string(), z.number()]),
        z.object({
          cptDiagnosesFormsetCode: z.string(),
          cptDiagnosesFormsetDiagnosis: zCodingOptional(),
          cptDiagnosesFormsetAddToProblemList: z.boolean().default(false),
        }),
      )
      .optional(),
    cptUnits: z.union([z.string(), z.number()]).optional(),
    cptModifiersFormset: z
      .record(
        z.union([z.string(), z.number()]),
        z.object({
          cptModifiersFormsetCode: z.string(),
          cptModifiersFormsetModifier: z.string(),
        }),
      )
      .optional(),
  })
  .refine(
    (data) => {
      if (data.cptCode?.code) {
        const diagnosesFormset = Object.values(data?.cptDiagnosesFormset ?? {});

        if (diagnosesFormset.length === 0) return false;

        const everyDiagnosisHasCode = diagnosesFormset.every(
          (diagnosis) => diagnosis.cptDiagnosesFormsetDiagnosis?.code,
        );

        return everyDiagnosisHasCode;
      }
      return true;
    },
    {
      message: "Diagnosis can't be empty",
      path: ["cptDiagnosesFormset"],
    },
  );

export type ProceduresFormType = z.infer<typeof ProceduresForm>;

export type ProceduresFormTypeWithId = ProceduresFormType & {
  id: string;
  exists: boolean;
  status?: QuestionnaireResponse["status"];
};

export default ProceduresForm;
